import Markdown from 'react-markdown';
import styled from 'styled-components';

import Button, {
  BaseButton,
  BaseButtonProps,
} from '#/components/Button/Button';
import { Container as FormInputContainer } from '#/components/Form/FormInput/FormInput.styled';
import { LinkButton } from '#/components/LinkButton';
import { cssPlanContainerBase } from '#/plugins/paywall/components';
import { ThemeConfig } from '#/service/config';
import { ButtonVariant } from '#/service/constants';
import { remify } from '#/service/utils';

interface Props {
  $hasBigText?: boolean;
}

export const ReceiptButton = styled(LinkButton)<Props>`
  font: ${({ $hasBigText }) =>
    $hasBigText ? `var(--fontStyleCallout)` : `var(--fontStyleFootnote)`};
`;

export const VoucherForm = styled.form`
  display: grid;
  grid-template-columns: auto max-content;
  column-gap: ${remify(10)};

  /* removing input margin */
  & ${FormInputContainer} {
    margin: 0;
  }
`;

export const VoucherFormSubmitButton = styled(Button)`
  font: var(--fontStyleFootnote);
  height: ${remify(50)};
`;

export const Receipt = styled.div`
  ${cssPlanContainerBase};
  margin-bottom: ${remify(48)};
`;

export const ReceiptLineBreak = styled.div`
  opacity: 0.12;
  margin: ${remify(16)} 0 ${remify(15)};
  width: 100%;
  height: 1px;
  background: var(--pageHeadingForeground);
`;

export const PaymentFormFooter = styled(Markdown)`
  font: var(--fontStyleCaption1);
  color: var(--pageParagraphForeground);
  text-align: center;
`;

export const Tabs = styled.div`
  display: flex;
  min-height: ${remify(48)};
  margin-bottom: ${remify(24)};
`;

interface TabProps extends Omit<BaseButtonProps, '$variant'> {
  $selected: boolean;
  theme: ThemeConfig;
}

export const Tab = styled(BaseButton).attrs(
  ({ theme: _theme, ...rest }: TabProps) => ({
    'aria-selected': rest.$selected,
    role: 'tab',
    $variant: ButtonVariant.Ghost,
    ...rest,
  })
)`
  display: inline-flex;
  flex: 1;
  justify-content: center;
  color: var(--buttonPrimaryBackground);
  border-radius: 0;

  ${({ $selected }) =>
    $selected &&
    `box-shadow: inset 0 -2px 0 0 var(--tabMenuHighlightBackground);`}
`;

export const TabPanel = styled.div.attrs(() => ({
  role: 'tabpanel',
  'data-testid': 'tab-panel',
}))<{ $selected: boolean }>`
  ${({ $selected }) => !$selected && `display: none;`}
`;

export const Icon = styled.img`
  height: ${remify(24)};
  margin-right: ${remify(8)};
`;

export const Text = styled.span`
  font: var(--fontStyleFootnote);
`;

export const DisclaimerWrapper = styled.div`
  margin: ${remify(45)} 0;
`;
